export var RdfTermType;
(function (RdfTermType) {
    RdfTermType["BlankNode"] = "BlankNode";
    RdfTermType["NamedNode"] = "NamedNode";
    RdfTermType["Literal"] = "Literal";
    RdfTermType["DefaultGraph"] = "DefaultGraph";
})(RdfTermType || (RdfTermType = {}));
export class RdfNode {
    static DEFAULT_GRAPH = "";
    termType;
    value;
    static namedNode(iri) {
        return {
            termType: RdfTermType.NamedNode,
            value: iri,
        };
    }
    static defaultGraph() {
        return {
            termType: RdfTermType.DefaultGraph,
            value: RdfNode.DEFAULT_GRAPH,
        };
    }
}
export class RdfObject extends RdfNode {
    datatype;
    language;
    static isNotNode(object) {
        return !this.isNode(object);
    }
    static isNode(object) {
        return (object.termType === RdfTermType.NamedNode ||
            object.termType === RdfTermType.BlankNode);
    }
    static isLiteral(object) {
        return object.termType === RdfTermType.Literal;
    }
}
//# sourceMappingURL=rdf-api.js.map